import {Wrench} from 'lucide-react';
import {Card, CardContent} from '@common-web/components/ui/card';

export function OnboardingMaintenanceView() {
  return (
    <div className='space-y-6'>
      <div className='bg-gradient-to-r from-slate-900 to-blue-900 text-white px-6 py-5 rounded-lg'>
        <div className='flex items-center gap-3'>
          <Wrench className='h-6 w-6 text-blue-300' />
          <div>
            <h1 className='text-xl font-bold'>Ongoing Maintenance</h1>
            <p className='text-sm text-blue-200'>Post-onboarding group management</p>
          </div>
        </div>
      </div>
      <Card>
        <CardContent className='flex flex-col items-center justify-center py-20'>
          <div className='bg-slate-100 rounded-full p-4 mb-4'>
            <Wrench className='h-10 w-10 text-slate-400' />
          </div>
          <h2 className='text-lg font-semibold text-slate-700 mb-2'>Coming Soon</h2>
          <p className='text-sm text-slate-500 text-center max-w-md'>
            The ongoing maintenance view will help you track and manage groups after they have
            completed the onboarding pipeline.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
